import styled from '../../../../styles/styledComponents/themeComponents';

export const HomeTabListFooterStyle = styled.div`
  display: flex;
  justify-content: space-between;

  .right {
    display: flex;

    button {
      margin-right: 10px;
    }
  }

  button {
    font-size: 18px;
    width: 100px;
  }
`;
